import { exists } from '@engine/lib/utility/exists';

function getSelectedSubFeatures(container) {
  return $(container).find('input[name="features[]"]:checked');
}

function getSubFeatures(container) {
  return $(container).find('input[name="features[]"]');
}

function getGroupContainer(group) {
  return '#merchant_' + group + '_group';
}

function getGroupCheckbox(group) {
  return $('#merchant_' + group);
}

function setupGroupCheckbox(group) {
  var container = getGroupContainer(group);
  var groupCheckbox = getGroupCheckbox(group);

  if (!exists(groupCheckbox)) {
    return;
  }

  var groupCheckboxElement = groupCheckbox[0];
  var selectedFeatures = getSelectedSubFeatures(container);
  var features = getSubFeatures(container);

  if (selectedFeatures.length === 0) {
    // no features supported
    groupCheckboxElement.indeterminate = false;
    groupCheckboxElement.checked = false;
  } else if (selectedFeatures.length === features.length) {
    // all features supported
    groupCheckboxElement.indeterminate = false;
    groupCheckboxElement.checked = true;
  } else {
    // some of features supported
    groupCheckboxElement.indeterminate = true;
    groupCheckboxElement.checked = false;
  }
}

function setupProcessing() {
  setupGroupCheckbox('feature_supports_api');
}

function setupTokenization() {
  setupGroupCheckbox('feature_supports_tokenization');
}

function setupReconcile() {
  setupGroupCheckbox('feature_supports_reconcile');
}

function setupGroupCheckboxes() {
  setupProcessing();
  setupTokenization();
  setupReconcile();
}

function listenForGroupUpdates(group, setupGroup) {
  var container = getGroupContainer(group);
  var groupCheckbox = getGroupCheckbox(group);
  var subFeaturesCheckboxes = getSubFeatures(container);
  groupCheckbox.on('change', function (_event) {
    var groupState = false;

    if (groupCheckbox[0].checked) {
      groupState = true;
    }

    subFeaturesCheckboxes.each(function (_, subFeatureCheckbox) {
      subFeatureCheckbox.checked = groupState;
    });
  });
  subFeaturesCheckboxes.on('change', function (_event) {
    setupGroup();
  });
}

function listenForUpdates() {
  listenForGroupUpdates('feature_supports_api', setupProcessing);
  listenForGroupUpdates('feature_supports_tokenization', setupTokenization);
  listenForGroupUpdates('feature_supports_reconcile', setupReconcile);
}

var SupportedFeatures = {
  listenForUpdates: listenForUpdates,
  setupGroupCheckboxes: setupGroupCheckboxes
};
export default SupportedFeatures;